<template>
    <main-content-wrapper>
        <h1 class="text-md-center">
            Včlanitev v Tuš Cash & Carry spletno trgovino
            <span>
                Hvala ker nam zaupate!
            </span>
        </h1>
        <v-layout justify-center row wrap fill-height >
            <v-flex xs12 md10 xl8 pl-5 pr-5 pt-4 pb-4 class="border">
                <consents-editor v-on:saved="onSaved" v-on:error="onErrorSaving($event)"></consents-editor>
            </v-flex>
        </v-layout>
        <v-snackbar
                v-model="errorSaving"
                color="error"
                top
        >
            {{ errorSavingMsg }}
            <v-btn
                    flat
                    @click="errorSaving = null"
            >
                Zapri
            </v-btn>
        </v-snackbar>
    </main-content-wrapper>
</template>

<script>

    import MainContentWrapper from "../components/MainContentWrapper";
    import Consents from "../components/Consents";
    import EmptySpace from "../components/EmptySpace";
    import SplitContent from "../components/SplitContent";
    import ConsentsEditor from "../components/ConsentsEditor";

    export default {
        name: "CreateAccountConsents",
        components: {ConsentsEditor, MainContentWrapper, Consents, EmptySpace, SplitContent},
        data: vm => ({
            loading: false,
            errorSaving: null,
            errorSavingMsg: null
        }),
        methods: {
            onSaved(){
                // onboarding step - existing members are forwarded to /api/login-done from there.
                // full reload so auth state is refreshed after email confirmation login.
                window.location.replace('/vclanitev?korak=registracija')
            },
            onErrorSaving(error){
                this.errorSaving = true;
                this.errorSavingMsg = error.message;
            }
        }
    }
</script>

<style scoped>

    .explain {
        font-size: 0.8em;
        color: #999999;
    }

</style>